import { Component, ElementRef, EventEmitter, HostListener, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import dayjs from 'dayjs/esm';
import { TimePeriod } from 'ngx-daterangepicker-material/daterangepicker.component';

@Component({
    selector: 'app-table-date-filter',
    templateUrl: './table-date-filter.component.html',
    styleUrls: ['./table-date-filter.component.scss'],
})
export class TableDateFilterComponent {
    @Input() selected: any = { startDate: null, endDate: null };
    @Input() locale = {
        customRangeLabel: 'Pick a range',
        applyLabel: 'Apply Filter',
        clearLabel: 'Clear Filter',
        format: 'DD/MM/YYYY',
        daysOfWeek: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
        monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        firstDay: 1,
    };
    @Input() placeholder = 'Date Range';
    @Input() ranges: any = {
        Today: [dayjs(), dayjs()],
        Yesterday: [dayjs().subtract(1, 'days'), dayjs().subtract(1, 'days')],
        'Last 7 Days': [dayjs().subtract(6, 'days'), dayjs()],
        'Last 30 Days': [dayjs().subtract(29, 'days'), dayjs()],
        'This Month': [dayjs().startOf('month'), dayjs().endOf('month')],
        'Last Month': [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')],
        'Last 3 Month': [dayjs().subtract(3, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')],
    };
    @Output() dateChange = new EventEmitter<any>();
    appliedDateRange: any = null;
    @ViewChild(TemplateRef, { static: true }) templateRef!: TemplateRef<void>;

    constructor(private eRef: ElementRef) {}

    maxDate = dayjs();
    isDateFilterApplied = false;

    onDateChange(event: TimePeriod) {
        this.appliedDateRange = {
            startDate: event?.startDate,
            endDate: event.endDate,
        };
        this.isDateFilterApplied = !!(event?.startDate && event?.endDate);
        this.dateChange.emit(this.appliedDateRange);
    }

    clearDateFilter() {
        this.appliedDateRange = null;
        this.isDateFilterApplied = false;
        this.dateChange.emit(null);
    }

    @HostListener('document:click', ['$event'])
    clickout(event: MouseEvent) {
        const clickedOutside = !this.eRef.nativeElement.contains(event.target);

        if (clickedOutside) {
            if (this.appliedDateRange?.startDate && this.appliedDateRange?.endDate) {
                this.selected = {
                    startDate: this.appliedDateRange.startDate,
                    endDate: this.appliedDateRange.endDate,
                };
            } else {
                this.selected = {
                    startDate: dayjs(),
                    endDate: dayjs(),
                };
            }
        }
    }
}
